import Select from '../../../components/select.vue'
import {store} from "../../../store/store";
import {api,getHallCode} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
export default {
  name:'searchbook',
  data(){
    return{
      webType:store.webType,
      categoryId:{'desc':'全部',categoryId:''},
      subCategoryId: {'desc': '全部', categoryId: ''},
      select: {desc: '全部',value:''},
      list: [{desc: '全部',value:''},{desc: '平台资讯',value:1}, {desc: ' 客户资讯',value:2}, {desc: '图书馆资讯',value:3}],
      libraryList: [{desc: '全部',value:''}, {desc: ' 客户资讯',value:2}, {desc: '图书馆资讯',value:3}],
      industry: {desc: '全部',value:''},
      industryList:[{desc: '全部',value:''},{desc: '文化类',value:1},{desc: '教育类',value:2}],
      isbn:"",
      name:"",
      author:"",
      publisher:"",
      publishDate:"",
      bookCategorys: [],//图书分类列表
      suBookCategorys: [],  //电子书分类列表
      libCode:"",
      hallCode:"", //图书馆网站
      fromSearch:0,//0表示首页高级搜索。1就是具体的高级搜索页面
      varietyId:{desc: '图书',varietyId:0},
      varietyList:[{desc: '图书',varietyId:0}, {desc: '电子书',varietyId:1}, {desc: '资讯',varietyId:2}],
      ajaxUrl:'', //请求api地址
      pageCount:3,
      pageNo:1,
      source:'',//来源
      title:'',//标题
    }
  },
  components:{
    Select,
  },
    watch: {
        categoryId(newValue, oldValue) {
            //如果电子书的第二个分类存在
            if(newValue.subList){
                this.suBookCategorys = newValue.subList;
                this.subCategoryId = this.suBookCategorys[0];
            }
        }
    },
    computed: {
        categoryDesc() {
            if (this.categoryId.desc == '全部') {
                return '全部'
            } else {
                return `${this.categoryId.desc}"` + '，' + `"${this.subCategoryId.desc}`
            }
        }
    },
  beforeMount() {
    this.fromSearch=this.$route.query.fromSearch;
    this.libCode=this.$route.query.libCode|| '';
    this.hallCode = this.$route.query.hallCode || '';
    //如果传参种类id为  0:图书，  1:电子书,   2:资讯
    if(this.$route.query.typeId == 0){
        this.varietyId = this.varietyList[0];
        this.ajaxUrl = api.book.category;  //请求图书分类数据
    }else if(this.$route.query.typeId == 1){
        this.varietyId = this.varietyList[1];
        this.ajaxUrl = api.ebook.category; //请求电子书分类数据
    }else{
        this.varietyId = this.varietyList[2];
        this.ajaxUrl = api.ebook.category; //请求资讯分类数据
    }
    this.getClassData()
  },
  methods: {
      //请求分类数据
      getClassData(){
          ajaxUtil.ajaxJson(this.ajaxUrl, null, "get",(data)=> {
              this.bookCategorys = data.map(function (item,index,c) {
                  item.desc = item.categoryName;
                  if (item.subList) {
                      item.subList.map((subItem, indx) => {
                          subItem.desc = subItem.categoryName;
                          return subItem
                      })
                      item.subList.unshift({'desc': '全部', categoryId: item.categoryId});
                  }
                  return item;
              });
              this.bookCategorys.unshift({'desc': '全部', categoryId: '', subList: [{desc: '全部', categoryId: ''}]});
              this.suBookCategorys = this.bookCategorys[0].subList
          },null,this);
      },
    search() {
        var pathStr='/indexsearch';
        if(this.varietyId.varietyId == 0){
            this.$router.push({path:pathStr ,
                query: {
                    categoryId: this.categoryId.categoryId,
                    categoryDesc: this.categoryId.desc,
                    isbn: this.isbn,
                    name: this.name,
                    author: this.author,
                    publisher: this.publisher,
                    publishDate: this.publishDate,
                    type:1,
                    fromSearch:this.fromSearch,
                    libCode:this.libCode,
                    hallCode: this.hallCode
                }});
        }else if(this.varietyId.varietyId == 1){
            var subCategoryId=this.subCategoryId.desc;
            if(subCategoryId!="全部"){
                subCategoryId=this.subCategoryId.categoryId;
            }else{
                subCategoryId="";
            }
            this.$router.push({
                path: pathStr,
                query: {
                    oneLevelCategoryId: this.categoryId.categoryId,
                    twoLevelCategoryId:subCategoryId ,
                    categoryDesc: this.categoryDesc,
                    isbn: this.isbn,
                    name: this.name,
                    author: this.author,
                    publisher: this.publisher,
                    publishDate: this.publishDate,
                    type: 2,
                    fromSearch: this.fromSearch,
                    libCode: this.libCode,
                    hallCode: this.hallCode
                }
            });
        }else{
            if(this.fromSearch!=1){
                pathStr="/indexsearch";
            }
            this.$router.push({path:pathStr ,
                query: {
                    category: this.select.value,
                    industry: this.industry.value,
                    categoryDesc:this.select.desc,
                    industryDesc:this.industry.desc,
                    libCode: this.libCode,
                    pageCount: this.pageCount,
                    pageNo: this.pageNo,
                    source:this.source,
                    title:this.title,
                    type:5,
                    fromSearch:this.fromSearch,
                    hallCode: this.hallCode
                }});
        }

    },
      //选择种类
      selectVariety(val){
        this.varietyId = val;
        this.categoryId = {'desc':'全部',categoryId:''};
        if(val.desc == '图书') {
            this.ajaxUrl = api.book.category;
            this.getClassData()
        }else if (val.desc == '电子书') {
            this.ajaxUrl = api.ebook.category;
            this.getClassData()
        }else{
            this.select = {desc: '全部',value:''};
            this.list = [{desc: '全部',value:''},{desc: '平台资讯',value:1}, {desc: ' 客户资讯',value:2}, {desc: '图书馆资讯',value:3}];
            this.libraryList= [{desc: '全部',value:''}, {desc: ' 客户资讯',value:2}, {desc: '图书馆资讯',value:3}];
            this.ajaxUrl = api.ebook.category;
            this.getClassData()
        }
      }
  },
}
